


import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft, FaStar } from "react-icons/fa";
console.log("🔥 PROBANDO .ENV:", process.env.REACT_APP_BACKEND_URL);


export default function AddReviewPage() {
  const navigate = useNavigate();
  const [nombre, setNombre] = useState("");
  const [email, setEmail] = useState("");
  const [comentario, setComentario] = useState("");
  const [rating, setRating] = useState(0);
  const [loading, setLoading] = useState(false);
  


  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!nombre || !email || !comentario || rating === 0) {
      alert("Por favor, completa todos los campos y selecciona una valoración.");
      return;
    }

    setLoading(true);
    console.log("🧩 Enviando reseña a Supabase...");

    try {
      console.log("📌 BACKEND URL USADA:", `${process.env.REACT_APP_BACKEND_URL}/api/reviews`);
console.log("📌 process.env.REACT_APP_BACKEND_URL:", process.env.REACT_APP_BACKEND_URL);
const backend = (process.env.REACT_APP_BACKEND_URL || "").trim();
const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/reviews`, {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify({ nombre, email, comentario, rating }),
});


const result = await res.json();

if (!res.ok) {
  alert("❌ Error al enviar la reseña: " + (result.error || ""));
  setLoading(false);
  return;
}

alert("✅ ¡Gracias por tu reseña!");
navigate("/");

} catch (err) {
  console.error("⚠️ Error inesperado:", err);
  alert("Ocurrió un error inesperado 😢");
}

  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #F4DDD6, #ffffff)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "40px 20px",
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          padding: "40px",
          borderRadius: "20px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
          maxWidth: "500px",
          width: "100%",
          position: "relative",
        }}
      >
        <button
          onClick={() => navigate(-1)}
          style={{
            position: "absolute",
            top: "20px",
            left: "20px",
            background: "none",
            border: "none",
            cursor: "pointer",
          }}
        >
          <FaArrowLeft size={22} color="#4B6CB7" />
        </button>

        <h2
          style={{
            textAlign: "center",
            color: "#333",
            marginBottom: "30px",
            fontSize: "26px",
            fontWeight: "700",
          }}
        >
          Deja tu reseña
        </h2>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: "15px" }}>
            <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>
              Nombre completo
            </label>
            <input
              type="text"
              value={nombre}
              onChange={(e) => setNombre(e.target.value)}
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "8px",
                border: "1px solid #ccc",
                fontSize: "15px",
              }}
              placeholder="Tu nombre"
            />
          </div>

          <div style={{ marginBottom: "15px" }}>
            <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>
              Correo electrónico
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "8px",
                border: "1px solid #ccc",
                fontSize: "15px",
              }}
              placeholder="tucorreo@ejemplo.com"
            />
          </div>

          <div style={{ marginBottom: "20px" }}>
            <label style={{ display: "block", marginBottom: "8px", fontWeight: "bold" }}>
              Valoración
            </label>
            <div style={{ display: "flex", gap: "8px" }}>
              {[1, 2, 3, 4, 5].map((num) => (
                <FaStar
                  key={num}
                  size={28}
                  color={num <= rating ? "#FFD700" : "#ccc"}
                  style={{ cursor: "pointer", transition: "color 0.2s" }}
                  onClick={() => setRating(num)}
                />
              ))}
            </div>
          </div>

          <div style={{ marginBottom: "25px" }}>
            <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>
              Comentario
            </label>
            <textarea
              value={comentario}
              onChange={(e) => setComentario(e.target.value)}
              style={{
                width: "100%",
                height: "120px",
                padding: "10px",
                borderRadius: "8px",
                border: "1px solid #ccc",
                resize: "none",
                fontSize: "15px",
              }}
              placeholder="Cuéntanos tu experiencia..."
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            style={{
              width: "100%",
              padding: "14px",
              background: loading
                ? "gray"
                : "linear-gradient(135deg, #4B6CB7, #182848)",
              color: "white",
              border: "none",
              borderRadius: "10px",
              fontSize: "16px",
              fontWeight: "600",
              cursor: "pointer",
            }}
          >
            {loading ? "Enviando..." : "Enviar reseña"}
          </button>
        </form>
      </div>
    </div>
  );
}
